<div class="app-container">
  <page-header
    *ngIf="productMovePack"
    [icon]="'far-exchange'"
    [title]="'productMovePack.type.' + productMovePack.type.id"
    [appendNoTranslationTitlePart]="productMovePack.number.toString()"
  >
    <ng-container class="header-button">
      <div class="d-flex align-items-center flex-gap-5">
        <btn
          *ngIf="productMovePack.url && productMovePack.url.length > 0"
          [label]="'download.pdf'"
          [title]="'download.pdf' | translate"
          [classes]="['btn-third', 'float-right']"
          [icon]="'far-file-pdf'"
          (onEvent)="downloadPdf()"
          data-cy="download-pdf"
        ></btn>
        <btn
          *ngIf="productMovePack.deletable && userCanDeleteProductMoves"
          [btnType]="'button'"
          [classes]="['btn-first-red', 'float-right', 'mr-2']"
          [btnDisabled]="loading"
          [label]="'delete'"
          [icon]="'far-trash-alt'"
          data-cy="delete-product"
          [title]="'delete' | translate"
          (onEvent)="deleteProductMovePack()"
        ></btn>
      </div>
    </ng-container>
    <ng-container class="back-button">
      <btn
        [label]="'back'"
        [title]="'back' | translate"
        [isBackButton]="true"
        [classes]="['btn-third', 'float-right', 'mr-2']"
        [icon]="'far-arrow-left'"
        (onEvent)="triggerBackBtn()"
      ></btn>
    </ng-container>
  </page-header>
  <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
  <div class="container-fluid" *ngIf="!!productMovePack">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 pl-0">
        <div class="card">
          <div>
            <h3 class="card-title">
              {{ 'info' | translate }}
            </h3>
          </div>
          <div class="table-responsive">
            <table class="table m-0">
              <tbody>
                <tr>
                  <td class="pl-0 card-subheading no-hover">
                    {{ 'dateCreated' | translate }}
                  </td>
                  <td class="text-right no-hover">
                    {{ productMovePack.dateCreated | strToDate | date: 'dd.MM.yyyy HH:mm' }}
                  </td>
                </tr>
                <tr>
                  <td class="pl-0 card-subheading no-hover">
                    {{ 'createdBy' | translate }}
                  </td>
                  <td class="text-right no-hover">
                    <a
                      class="link"
                      *ngIf="productMovePack.createdBy"
                      [routerLink]="['/user', productMovePack.createdBy.id]"
                      >{{
                        productMovePack.createdBy && productMovePack.createdBy
                          ? productMovePack.createdBy.firstName +
                            ' ' +
                            productMovePack.createdBy.lastName +
                            ' (' +
                            productMovePack.createdBy.email +
                            ')'
                          : ''
                      }}</a
                    >
                  </td>
                </tr>
                <tr *ngIf="productMovePack.depotFrom && productMovePack.depotFrom.id > 0">
                  <td class="pl-0 card-subheading no-hover">{{ 'depotFrom' | translate }}</td>
                  <td class="text-right no-hover">
                    <a class="link" [routerLink]="['/depot', productMovePack.depotFrom.id]">{{
                      productMovePack.depotFrom.name
                    }}</a>
                  </td>
                </tr>
                <tr *ngIf="productMovePack.depotTo && productMovePack.depotTo.id > 0">
                  <td class="pl-0 card-subheading no-hover">{{ 'depotTo' | translate }}</td>
                  <td class="text-right no-hover">
                    <a class="link" [routerLink]="['/depot', productMovePack.depotTo.id]">{{
                      productMovePack.depotTo.name
                    }}</a>
                  </td>
                </tr>
                <tr *ngIf="productMovePack?.checkout?.id">
                  <td class="pl-0 card-subheading no-hover">{{ 'productMovePack.surgery' | translate }}</td>
                  <td class="text-right">{{ productMovePack.checkout ? productMovePack.checkout?.name : '' }}</td>
                </tr>
                <tr *ngIf="productMovePack?.purchaseOrder?.id">
                  <td class="pl-0 card-subheading no-hover">{{ 'purchase.detail' | translate }}</td>
                  <td class="text-right">
                    <a class="link" [routerLink]="['/purchase-order', productMovePack.purchaseOrder.id]">{{
                      productMovePack.purchaseOrder ? productMovePack.purchaseOrder?.externalReference : ''
                    }}</a>
                  </td>
                </tr>
                <tr *ngIf="productMovePack?.incidentalCosts > 0">
                  <td class="pl-0 card-subheading no-hover">{{ 'operationAddedCosts' | translate }}</td>
                  <td class="text-right">
                    {{
                      productMovePack.incidentalCosts | formatPrice: productMovePack.moves[0]?.product?.purchaseCurrency
                    }}
                  </td>
                </tr>
                <tr *ngFor="let move of productMovePack.moves | slice: 0 : 1">
                  <td class="pl-0 card-subheading no-hover text-nowrap">
                    {{ 'bill.quantity' | translate }} / {{ 'bill.amount' | translate }}
                  </td>
                  <td class="text-right no-hover">
                    <div class="flex-gap-10 flex-row-reverse">
                      <strong>{{ quantityItemsSum }}</strong>
                      <strong>/</strong>
                      <strong>{{ productMovePack.moves | listLength }}</strong>
                    </div>
                  </td>
                </tr>
                <tr></tr>
                <tr *ngIf="productMovePack?.externalId">
                  <td class="pl-0 card-subheading no-hover">
                    {{ 'externalId' | translate }}
                  </td>
                  <td class="text-right no-hover">
                    {{ productMovePack.externalId }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div
        class="col-12 col-sm-12 col-md-6 col-lg-8 col-xl-8 pr-0"
        *ngIf="productMovePack?.note?.length > 0 || productMovePack?.files?.length > 0"
      >
        <div class="card" *ngIf="productMovePack?.note?.length > 0">
          <div class="row col" style="margin-bottom: 0.5rem">
            <h3 class="card-title">
              {{ 'note' | translate }}
            </h3>
          </div>
          <div [innerHtml]="productMovePack.note | nl2br">
            {{ productMovePack?.note }}
          </div>
        </div>
        <div class="card" *ngIf="productMovePack?.files?.length > 0">
          <div class="row col" style="margin-bottom: 0.5rem">
            <h3 class="card-title">
              {{ 'files' | translate }}
            </h3>
          </div>
          <div>
            <div *ngFor="let f of productMovePack.files">
              <i
                class="fa fa-file-image"
                *ngIf="!!f.mimeType && (f.mimeType.includes('jpg') || f.mimeType.includes('jpeg'))"
              ></i>
              <i class="fa fa-file-pdf" *ngIf="!!f.mimeType && f.mimeType.includes('pdf')" title="PDF"></i>
              &nbsp;&nbsp;
              <a class="link" href="{{ f.url }}" target="_blank">{{ f.originalFilename }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="productMovePack.moves && productMovePack.moves.length > 0">
      <div class="col-12 col-md-12 pl-0 pr-0">
        <div class="card">
          <div class="box box-default">
            <div class="box-body">
              <div class="table-responsive">
                <table class="table m-0" [photoGalleryGroup]="{ index: 1 }">
                  <thead>
                    <tr>
                      <th class="pl-0 text-nowrap">{{ 'product.name' | translate }}</th>
                      <th class="text-center d-xl-table-cell">{{ 'product.code' | translate }}</th>
                      <th class="text-center">{{ 'product.code2' | translate }}</th>
                      <th class="text-center" *ngIf="productMovePack.type?.id === 'in'">
                        {{ 'supplier' | translate }}
                      </th>
                      <th class="text-center">
                        {{ atLeastOneProductHasBatchExpirationModeEnabled ? ('product.batch' | translate) : '' }}
                      </th>
                      <th class="text-center">
                        {{ atLeastOneProductHasBatchExpirationModeEnabled ? ('expiration' | translate) : '' }}
                      </th>
                      <th class="text-center" *ngIf="companyUtil.arePositionsEnabled">{{ 'position' | translate }}</th>
                      <th class="text-center">{{ 'bill.qty' | translate }}</th>
                      <th class="text-right">{{ 'productMovePack.purchasePrice' | translate }}</th>
                      <th class="text-right">{{ 'productMovePack.purchasePrice.amount.sum' | translate }}</th>
                      <th class="text-right">&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody *ngFor="let move of productMovePack.moves">
                    <tr *ngIf="move && productMovePack.type?.id === 'in'">
                      <td
                        class="pl-1 no-hover"
                        *ngIf="move.productDepotTo && move.productDepotTo.product && move.productDepotTo.product.id > 0"
                      >
                        <div class="flex-gap-10 align-items-center" [photoGalleryGroup]="{ index: 2 }">
                          <div
                            [photoGallery]="getThumbUrl(move.productDepotTo.product.mainImage, 'w2048wp')"
                            [photoGalleryCaption]="
                              move.productDepotTo.product.name +
                              '<br>' +
                              (move.productDepotTo.product.code
                                ? ('productMovePack.code' | translate) + move.productDepotTo.product.code
                                : '') +
                              '<br>' +
                              (move.productDepotTo.product.ean
                                ? ('productMovePack.ean' | translate) + move.productDepotTo.product.ean
                                : '')
                            "
                          >
                            <div class="images-item">
                              <img
                                class="images-item-image"
                                [src]="getThumbUrl(move.productDepotTo.product.mainImage)"
                                [alt]="move.productDepotTo.product.name"
                              />
                            </div>
                          </div>
                          <div>
                            <div>
                              <a class="link-bold" [routerLink]="['/product', move.productDepotTo.product.id]">
                                {{ move.productDepotTo.product.name }}
                              </a>
                            </div>
                            <div class="product-details flex-gap-5 flex-wrap d-xl-none">
                              <div
                                *ngIf="move.productDepotTo.product.code && move.productDepotTo.product.code.length > 0"
                              >
                                {{ 'product.code' | translate }}:<span> {{ move.productDepotTo.product.code }}</span>
                              </div>
                              <div
                                *ngIf="move.productDepotTo.product.ean && move.productDepotTo.product.ean.length > 0"
                              >
                                {{ 'product.ean' | translate }}:<span> {{ move.productDepotTo.product.ean }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td class="text-center text-nowrap no-hover d-xl-table-cell">
                        {{
                          move.productDepotTo && move.productDepotTo.product ? move.productDepotTo.product.code : '--'
                        }}
                      </td>
                      <td class="text-center text-nowrap no-hover d-xl-table-cell">
                        {{
                          move.productDepotTo && move.productDepotTo.product ? move.productDepotTo.product.code2 : '--'
                        }}
                      </td>
                      <td
                        class="text-center text-nowrap no-hover d-xl-table-cell"
                        *ngIf="productMovePack.type?.id === 'in'"
                      >
                        {{
                          move.productDepotTo && move.productDepotTo.supplier ? move.productDepotTo.supplier.name : '--'
                        }}
                      </td>
                      <td class="text-nowrap text-center">
                        {{
                          atLeastOneProductHasBatchExpirationModeEnabled
                            ? move.productDepotTo?.batch
                              ? move.productDepotTo.batch
                              : '--'
                            : ''
                        }}
                      </td>
                      <td class="text-center text-nowrap no-hover">
                        {{
                          atLeastOneProductHasBatchExpirationModeEnabled
                            ? move.productDepotTo?.expirationDate?.length > 0
                              ? (move.productDepotTo?.expirationDate | fmtDate: 'dd.MM.yyyy')
                              : '--'
                            : ''
                        }}
                      </td>
                      <td class="text-center text-nowrap" *ngIf="companyUtil.arePositionsEnabled">
                        {{ !!move.productDepotTo?.position ? move.productDepotTo.position : '--' }}
                      </td>
                      <td class="text-center text-nowrap no-hover">{{ move.amount }}</td>
                      <td class="text-right no-hover">
                        {{ move.purchasePriceWithVat | formatPrice: move.product.purchaseCurrency }}
                      </td>
                      <td class="text-right">
                        {{ move.purchasePriceAllWithVat | formatPrice: move.product.purchaseCurrency }}
                      </td>
                      <td class="text-right">
                        <btn
                          *ngIf="move.deletable && userCanDeleteProductMoves"
                          [btnType]="'button'"
                          [classes]="['btn-second']"
                          (onEvent)="deleteProductMove(move)"
                          [icon]="'far-trash-alt'"
                          [title]="'delete' | translate"
                          data-cy="delete-row-category"
                        ></btn>
                      </td>
                    </tr>
                    <tr *ngIf="move && productMovePack.type?.id === 'out'">
                      <td
                        class="no-hover"
                        *ngIf="
                          move.productDepotFrom && move.productDepotFrom.product && move.productDepotFrom.product.id > 0
                        "
                      >
                        &nbsp;
                        <a class="link" [routerLink]="['/product', move.productDepotFrom.product.id]"
                          ><strong>{{ move.productDepotFrom.product.name }}</strong></a
                        >
                      </td>
                      <td class="text-center no-hover d-xl-table-cell">
                        {{
                          move.productDepotFrom && move.productDepotFrom.product
                            ? move.productDepotFrom.product.code
                            : '--'
                        }}
                      </td>
                      <td class="text-center no-hover d-xl-table-cell">
                        {{
                          move.productDepotFrom && move.productDepotFrom.product
                            ? move.productDepotFrom.product.code2
                            : '--'
                        }}
                      </td>
                      <td class="text-center no-hover">
                        {{
                          atLeastOneProductHasBatchExpirationModeEnabled
                            ? move.productDepotFrom.batch?.length > 0
                              ? move.productDepotFrom.batch
                              : '--'
                            : ''
                        }}
                      </td>
                      <td class="text-center no-hover">
                        {{
                          atLeastOneProductHasBatchExpirationModeEnabled
                            ? move.productDepotFrom.expirationDate?.length > 0
                              ? (move.productDepotFrom.expirationDate | fmtDate: 'dd.MM.yyyy')
                              : '--'
                            : ''
                        }}
                      </td>
                      <td class="text-center no-hover" *ngIf="companyUtil.arePositionsEnabled">
                        {{
                          !!move.productDepotFrom.position && move.productDepotFrom.position.length > 2
                            ? move.productDepotFrom.position
                            : '--'
                        }}
                      </td>
                      <td class="text-right no-hover">{{ move.amount }}</td>
                      <td class="text-right no-hover">
                        {{ move.purchasePriceWithVat | formatPrice: move.product.purchaseCurrency }}
                      </td>
                      <td class="text-right">
                        {{ move.purchasePriceAllWithVat | formatPrice: move.product.purchaseCurrency }}
                      </td>
                      <td class="text-right">
                        <btn
                          *ngIf="move.deletable && userCanDeleteProductMoves"
                          [btnType]="'button'"
                          [classes]="['btn-second']"
                          (onEvent)="deleteProductMove(move)"
                          [icon]="'far-trash-alt'"
                          [title]="'delete' | translate"
                          data-cy="delete-row-category"
                        ></btn>
                      </td>
                    </tr>
                    <tr *ngIf="move && productMovePack.type?.id === 'transfer'">
                      <td
                        class="no-hover"
                        *ngIf="
                          move.productDepotFrom && move.productDepotFrom.product && move.productDepotFrom.product.id > 0
                        "
                      >
                        &nbsp;
                        <a class="link" [routerLink]="['/product', move.productDepotFrom.product.id]"
                          ><strong>{{ move.productDepotFrom.product.name }}</strong></a
                        >
                      </td>
                      <td class="text-center no-hover" *ngIf="move.productDepotFrom && !move.productDepotFrom.product">
                        <strong>&nbsp;</strong>
                      </td>
                      <td class="text-center no-hover">
                        {{
                          move.productDepotFrom && move.productDepotFrom.product
                            ? move.productDepotFrom.product.code
                            : '--'
                        }}
                      </td>
                      <td class="text-center no-hover">
                        {{
                          move.productDepotFrom && move.productDepotFrom.product
                            ? move.productDepotFrom.product.code2
                            : '--'
                        }}
                      </td>
                      <td class="text-center no-hover">
                        {{
                          atLeastOneProductHasBatchExpirationModeEnabled
                            ? move.productDepotFrom.batch?.length > 0
                              ? move.productDepotFrom.batch
                              : '--'
                            : ''
                        }}
                      </td>
                      <td class="text-center no-hover">
                        {{
                          atLeastOneProductHasBatchExpirationModeEnabled
                            ? move.productDepotTo?.expirationDate?.length > 0
                              ? (move.productDepotTo?.expirationDate | fmtDate: 'dd.MM.yyyy')
                              : '--'
                            : ''
                        }}
                      </td>
                      <td class="text-center no-hover" *ngIf="companyUtil.arePositionsEnabled">
                        {{
                          !!move.productDepotFrom.position && move.productDepotFrom.position.length > 2
                            ? move.productDepotFrom.position
                            : '--'
                        }}
                        <i class="fal fa-arrow-right m-2"></i>
                        {{
                          !!move.productDepotTo.position && move.productDepotTo.position.length > 2
                            ? move.productDepotTo.position
                            : '--'
                        }}
                      </td>
                      <td class="text-right no-hover">{{ move.amount }}</td>
                      <td class="text-right no-hover">
                        {{ move.purchasePriceWithVat | formatPrice: move.product.purchaseCurrency }}
                      </td>
                      <td class="text-right">
                        {{ move.purchasePriceAllWithVat | formatPrice: move.product.purchaseCurrency }}
                      </td>
                      <td class="text-right">
                        <btn
                          *ngIf="move.deletable && userCanDeleteProductMoves"
                          (onEvent)="deleteProductMove(move)"
                          [btnType]="'button'"
                          [classes]="['btn-second']"
                          [icon]="'far-trash-alt'"
                          [title]="'delete' | translate"
                          data-cy="delete-row-category"
                        ></btn>
                      </td>
                    </tr>
                    <tr *ngIf="move && move.note && move.note.length" style="font-style: italic">
                      <td class="no-hover" colspan="7" [innerHtml]="move.note | nl2br"></td>
                    </tr>
                  </tbody>
                  <tbody class="row-sum">
                    <tr>
                      <td
                        class="td-invisible border-0 no-hover"
                        [colSpan]="productMovePack.type?.id === 'in' ? (companyUtil.arePositionsEnabled ? 6 : 5) : companyUtil.arePositionsEnabled ? 5 : 4"
                      >
                        &nbsp;
                      </td>
                      <td class="text-right border-0 text-nowrap font-weight-bold">
                        {{ 'numberOfItems.total' | translate }}
                      </td>
                      <td class="text-center border-0 no-hover text-nowrap font-weight-bold">
                        {{ productMovePack ? getProductMovePackTotalAmount() : 0 }}
                      </td>
                      <td class="text-right border-0 text-nowrap font-weight-bold">{{ 'price.total' | translate }}</td>
                      <td class="text-right border-0 no-hover text-nowrap font-weight-bold">
                        {{
                          productMovePack.purchasePriceWithVat
                            | formatPrice: productMovePack.moves[0]?.product?.purchaseCurrency
                        }}
                      </td>
                      <td *ngIf="canCreateOrEdit" class="td-invisible no-hover">&nbsp;</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
